function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M329.3,241.016c22.741-.414,34.811,6.341,51.172,10.937,1.488,5.167.3,14.176-1.172,18.359-11.377-.644-21.281-8.557-32.031-11.328-21.825-5.623-41.205,3.856-53.516,11.719-1.181-.492-0.467.007-1.172-0.781-4.8-16.948,13.155-24.1,24.219-26.953Zm130.859,1.562c19.535-.531,47.9,3.111,41.406,26.172H500c-15.041-13.366-39.791-10.014-60.156-3.906-6.019,1.805-15.447,7.739-21.485,6.64V270.7c-1.546-3.615-1.566-13.809-.39-17.969L441.8,245.7Z"
});

var SvgMEyebrowshapeRoundedVector = function SvgMEyebrowshapeRoundedVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m_eyebrowshape_rounded_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMEyebrowshapeRoundedVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_eyebrowshape_rounded_vector.4a719fc3.svg";
export { ForwardRef as ReactComponent };